import * as types from '../mutation-types'
import { REPO_TYPE_BIOCONDUCTOR, REPO_TYPE_PYTHON, REPO_TYPE_R } from '../../constants/repo-types'

export const mutations = {
  [types.SET_GOT_REPOS] (state, flag) {
    state.gotRepos = flag
  },
  [types.RECEIVE_REPOS] (state, { repos }) {
    state.allRepos = repos
  },
  [types.SET_CURRENT_REPO] (state, desiredRepoId) {
    let repoId
    let repoType
    if (state.allRepos.length) {
      const foundRepo = state.allRepos.find(repo => { return repo.id === desiredRepoId })
      if (foundRepo) {
        repoId = foundRepo.id
        repoType = foundRepo.type
      }
    }
    state.currentRepoId = repoId
    state.currentRepoType = repoType
    state.currentRepoSources = undefined
  },
  [types.SET_FIRST_REPO_CURRENT] (state) {
    const repoTypeOrder = [REPO_TYPE_R, REPO_TYPE_BIOCONDUCTOR, REPO_TYPE_PYTHON]
    let foundRepoId
    repoTypeOrder.some(t => {
      const firstRepo = state.allRepos.find(r => r.type === t)
      if (firstRepo) {
        foundRepoId = firstRepo.id
        return true
      }
    })
    state.currentRepoId = foundRepoId
    state.currentRepoSources = undefined
  },
  [types.RECEIVE_REPO_SOURCES] (state, { data }) {
    state.currentRepoSources = data
    if (data && data.length > 0) {
      state.currentRepoSource = data[0].id
      state.currentRepoSourceType = data[0].type
    } else {
      state.currentRepoSource = undefined
      state.currentRepoSourceType = undefined
    }
  },
  [types.SET_CURRENT_SOURCE] (state, source) {
    state.currentRepoSource = source.id
    state.currentRepoSourceType = source.type
  },
  [types.SET_GETTING_REPO_SYSTEM_DEPENDENCIES] (state, flag) {
    state.gettingRepoSystemDependencies = flag
    if (flag) {
      state.currentRepoSystemDependencies = undefined
    }
  },
  [types.RECEIVE_REPO_SYSTEM_DEPENDENCIES] (state, { requirements }) {
    state.currentRepoSystemDependencies = requirements
  },
  [types.SET_GETTING_URL] (state, flag) {
    state.gettingRepoUrl = flag
    if (flag) {
      state.currentRepoUrlInfo = undefined
    }
  },
  [types.RECEIVE_URL_INFO] (state, { data }) {
    if (data) {
      state.gettingRepoUrl = false
      state.currentRepoUrlInfo = data
    }
  },
  [types.SET_GETTING_DECODED_URL] (state, flag) {
    state.gettingDecodedUrl = flag
    if (flag) {
      state.currentDecodedUrlInfo = undefined
    }
  },
  [types.RECEIVE_DECODED_URL_INFO] (state, { data }) {
    if (data) {
      state.gettingDecodedUrl = false
      state.currentDecodedUrlInfo = data
    }
  },
}

const module = HTTP => ({
  state: {
    gotRepos: false,
    allRepos: [],
    currentRepoId: undefined,
    currentRepoType: undefined,
    currentRepoSources: undefined,
    currentRepoSource: undefined,
    currentRepoSourceType: undefined,
    gettingRepoSystemDependencies: false,
    currentRepoSystemDependencies: undefined,
    currentRepoUrlInfo: undefined,
    gettingRepoUrl: false,
    gettingDecodedUrl: false,
    currentDecodedUrlInfo: undefined,
  },
  mutations,
  actions: {
    async getAllRepos ({ commit, dispatch, state }, desiredRepoId) {
      try {
        const response = await HTTP.get('/repos')
        const repos = response.data
        commit(types.RECEIVE_REPOS, { repos })
        await dispatch('setRepoId', { repoId: desiredRepoId })
        commit(types.SET_GOT_REPOS, true)
      } catch (e) {
        console.log(e)
      }
    },
    async setRepoId ({ commit, dispatch }, params) {
      commit(types.SET_CURRENT_REPO, params.repoId)
      if (params.repoId && params.repoId > 0) {
        await dispatch('getRepoSources', params)
      }
    },
    async setFirstRepoCurrent ({ commit, dispatch, state }, params) {
      commit(types.SET_FIRST_REPO_CURRENT)
      if (state.currentRepoId) {
        await dispatch('getRepoSources', { repoId: state.currentRepoId })
      }
    },
    async getRepoSources ({ commit }, params) {
      try {
        const response = await HTTP.get(`/repos/${params.repoId}/sources?internal=true`)
        const data = response.data
        commit(types.RECEIVE_REPO_SOURCES, { data })
      } catch (e) {
        console.log(e)
      }
    },
    async getRepoSystemDependencies ({ commit, state, rootState }, params) {
      try {
        commit(types.SET_GETTING_REPO_SYSTEM_DEPENDENCIES, true)
        const { repoId, os } = params
        let biocVersionQuery = ''
        if (state.currentRepoType === REPO_TYPE_BIOCONDUCTOR) {
          biocVersionQuery = `&bioc_version=${rootState.packages.selectedBiocVersion.bioc_version}`
        }
        const response = await HTTP.get(`/repos/${repoId}/sysreqs?all=true&distribution=${os.distribution}&release=${os.release}${biocVersionQuery}`)

        const data = response.data
        commit(types.RECEIVE_REPO_SYSTEM_DEPENDENCIES, { requirements: data.requirements })
        commit(types.SET_GETTING_REPO_SYSTEM_DEPENDENCIES, false)
      } catch (e) {
        commit(types.SET_GETTING_REPO_SYSTEM_DEPENDENCIES, false)
        console.log(e)
      }
    },
    async getRepoUrl ({ commit }, params) {
      commit(types.SET_GETTING_URL, true)
      try {
        const response = await HTTP.post('/url', { repo: params.repoName, snapshot: params.snapshot, locked: params.locked })
        const data = response.data
        commit(types.RECEIVE_URL_INFO, { data })
        commit(types.SET_GETTING_URL, false)
      } catch (e) {
        commit(types.SET_GETTING_URL, false)
        console.log(e)
      }
    },
    async getDecodedUrl ({ commit }, upsi) {
      commit(types.SET_GETTING_DECODED_URL, true)
      try {
        const response = await HTTP.get('/url/' + upsi)
        const data = response.data
        commit(types.RECEIVE_DECODED_URL_INFO, { data })
        commit(types.SET_GETTING_DECODED_URL, false)
      } catch (e) {
        commit(types.SET_GETTING_DECODED_URL, false)
        console.log(e)
      }
    },
    async clearDecodedUrl ({ commit }) {
      commit(types.SET_GETTING_DECODED_URL, true)
      try {
        commit(types.RECEIVE_DECODED_URL_INFO, { undefined })
        commit(types.SET_GETTING_DECODED_URL, false)
      } catch (e) {
        commit(types.SET_GETTING_DECODED_URL, false)
        console.log(e)
      }
    },
  },
  getters: {
    currentRepo: state => {
      return state.allRepos.find(repo => { return repo.id === state.currentRepoId })
    },
  },
})

export default {
  module,
}
